var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"watershed-display box pt-1 pb-1"},[(_vm.watershed)?_c('p',[_vm._v(" "+_vm._s(_vm.watershed)+" ")]):_c('p',[_vm._v(" "+_vm._s(_vm.$t('HOVER_TEXT'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }